// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "3b1e5ed454ca16f2364f2b1f21652425" + ".js";
};